import { RouteObject } from 'react-router';
import { AddUpdate } from '@/const';
import UserListPage from './pages/user/list';
import UserUpdatePage from './pages/user/update';
import { GroupListPage, GroupUpdatePage } from './pages/groups';

export const routes: RouteObject[] = [
  {
    path: 'account',
    children: [
      {
        path: 'user',
        element: <UserListPage appName={'account'} model={'user'} />,
      },
      {
        path: `user${AddUpdate}`,
        element: <UserUpdatePage appName={'account'} model={'user'} />,
      },
      {
        path: 'group',
        element: <GroupListPage appName={'auth'} model={'group'} />,
      },
      {
        path: `group${AddUpdate}`,
        element: <GroupUpdatePage appName={'auth'} model={'group'} />,
      },
    ],
  },
];
